import { render } from "./ParkingSticker.vue?vue&type=template&id=8cf7585e&scoped=true"
import script from "./ParkingSticker.vue?vue&type=script&lang=js"
export * from "./ParkingSticker.vue?vue&type=script&lang=js"

import "./ParkingSticker.vue?vue&type=style&index=0&id=8cf7585e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cf7585e"]])

export default __exports__